import { EvalStatuses } from '../pages/MyPeopleEvalPage/enums/EvalStatuses';

export const ALL_EVAL_STATUSES: EvalStatuses[] = [
  EvalStatuses.PendingToStart,
  EvalStatuses.Upcoming,
  EvalStatuses.PendingToClose,
  EvalStatuses.Ongoing,
  EvalStatuses.Closed,
  EvalStatuses.Cancelled,
];

/**
 * Converts frontend status filters to backend-compatible status array.
 * "All" expands to all 6 individual statuses.
 * All other statuses pass through as-is.
 *
 * @param statusFilters - Array of frontend status filters
 * @returns Status array to send to the backend, or undefined to omit the param
 */
export const convertToBackendFilters = (statusFilters: EvalStatuses[]): EvalStatuses[] | undefined => {
  if (!statusFilters?.length) {
    return undefined;
  }

  if (statusFilters.includes(EvalStatuses.All)) {
    return [...ALL_EVAL_STATUSES];
  }

  return [...statusFilters];
};
